<template>
    <button
        type="button"
        class="w-full flex items-center justify-center gap-1.5 rounded-full border border-valence-grey-300 bg-white px-3.5 py-1.5 body-small text-valence-grey-600 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed"
        :disabled="disabled"
        @click="emit('click')">
        <i class="bi text-base leading-none text-[#f2c06e]" :class="isPrioritized ? 'bi-star-fill' : 'bi-star'" aria-hidden="true"></i>
        {{ isPrioritized ? prioritizedText : unprioritizedText }}
    </button>
</template>

<script setup lang="ts">
const {
    isPrioritized = false,
    prioritizedText = "Remove from priority goals",
    unprioritizedText = "Make this a priority goal",
    disabled = false,
} = defineProps<{
    isPrioritized?: boolean;
    prioritizedText?: string;
    unprioritizedText?: string;
    disabled?: boolean;
}>();

const emit = defineEmits<{ click: [] }>();
</script>
